import {
  ButtonGroup,
  Table,
  TableContainer,
  Tag,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
} from "@chakra-ui/react";
import ButtonRemoveResource from "components/ButtonRemoveResource";
import ActiveTag from "components/ui/ActiveTag";
import AvatarPaper from "components/ui/AvatarPaper";
import ButtonEdit from "components/ui/ButtonEdit";
import DateTime from "components/ui/DateTime";
import { useSearchContext } from "contexts/SearchContext";

export const CONTENT_GROUP_TYPE_NAMES = {
  REPORT: "Report",
  AGENDA: "Agenda",
  NEWSLETTER: "Newsletter",
};

export const CONTENT_GROUP_TYPE_COLORS = {
  REPORT: "blue",
  AGENDA: "purple",
  NEWSLETTER: "green",
};

export default function ContentGroupsList() {
  const { data: contentGroups } = useSearchContext();

  return (
    <TableContainer>
      <Table>
        <Thead>
          <Tr>
            <Th>Nome</Th>
            <Th>Tipo</Th>
            <Th>Disparos</Th>
            <Th>Status</Th>
            <Th>Cadastrado em</Th>
            <Th w="120px"></Th>
          </Tr>
        </Thead>
        <Tbody>
          {contentGroups &&
            contentGroups.map((contentGroup) => (
              <Tr key={`content-group-${contentGroup.id}`}>
                <Td>
                  <AvatarPaper
                    bg="white.100"
                    borderColor="gray.300"
                    borderWidth="1px"
                    color="gray.800"
                  />
                  {contentGroup.name}
                </Td>
                <Td>
                  <Tag
                    colorScheme={CONTENT_GROUP_TYPE_COLORS[contentGroup.type]}
                  >
                    {CONTENT_GROUP_TYPE_NAMES[contentGroup.type]}
                  </Tag>
                </Td>
                <Td>
                  {contentGroup.type === "REPORT"
                    ? contentGroup._count.contents
                    : contentGroup._count.agendas}{" "}
                  disparos
                </Td>
                <Td>
                  <ActiveTag isActive={contentGroup.active} />
                </Td>
                <Td>
                  <DateTime date={contentGroup.createdAt} />
                </Td>
                <Td textAlign="right">
                  <ButtonGroup>
                    <ButtonEdit to={`/modelos-de-disparo/${contentGroup.id}`} />
                    <ButtonRemoveResource
                      id={contentGroup.id}
                      pathName="content-groups"
                      queryKey="search-contentGroups"
                    />
                  </ButtonGroup>
                </Td>
              </Tr>
            ))}
        </Tbody>
      </Table>
    </TableContainer>
  );
}
